/**
 *
 * IpData Selectors
 *
 */

import { createSelector } from 'reselect';

const getIpDataRoot = state => state.ipData;

export const getIpData = createSelector(
  getIpDataRoot,
  ipData => ipData && ipData.data,
);
